package horcrux.browserapp.clients

import horcrux.frontend.common.analytics.AnalyticsEvent
import horcrux.frontend.common.analytics.PageViewEvent
import horcrux.frontend.common.analytics.ScreenViewEvent
import horcrux.frontend.common.clients.AnalyticsClient
import horcrux.browserapp.configs.FirebaseConfigs
import horcrux.browserapp.externals.firebase.Analytics
import horcrux.browserapp.externals.firebase.AnalyticsSettings
import horcrux.browserapp.externals.firebase.FirebaseApp
import horcrux.browserapp.externals.firebase.FirebaseOptions
import horcrux.browserapp.externals.firebase.wrappers.isSupported
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.await
import kotlinx.coroutines.launch

class AnalyticsClientImpl : AnalyticsClient {
    override fun log(event: AnalyticsEvent): Unit? = analyticsMaybe?.log(
        when (event) {
            is PageViewEvent -> Analytics.Event.PageView(title = event.eventName)
            is ScreenViewEvent -> Analytics.Event.ScreenView(title = event.eventName)
        }
    )

    companion object {
        private var analyticsMaybe: Analytics? = run {
            initializeAnalytics()
            null
        }

        private fun initializeAnalytics() {
            GlobalScope.launch {
                if (isSupported().await()) {
                    val app =
                        FirebaseApp.initialize(FirebaseOptions(FirebaseConfigs.FIREBASE_OPTIONS), name = "analytics")
                    app.initializeAnalytics(AnalyticsSettings())
                    val analytics = app.getAnalytics()
                    analytics.setAnalyticsCollectionEnabled(true)
                    analyticsMaybe = analytics
                }
            }
        }
    }
}
